import React, { useEffect } from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import InfoIcon from "@mui/icons-material/Info";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import TrashIcon from "@mui/icons-material/Delete";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import CropRotateIcon from "@mui/icons-material/CropRotate";
import CopyAllIcon from "@mui/icons-material/CopyAll";
import SendIcon from "@mui/icons-material/Send";
import PermIdIcon from "@mui/icons-material/PermIdentitySharp";

import useActions, { useAppDispatch, useAppSelector } from "../../app/hooks";
import IconButton from "@mui/material/IconButton";
import ImageListItem from "@mui/material/ImageListItem";
import ImageListItemBar from "@mui/material/ImageListItemBar";
import { Workspace } from "../../types/Dash";
import { Folder } from "../../types/Folder";
import { User } from "../../types/User";
import { Role } from "../../types/Role";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import DashInfoForm from "./DashInfoForm";
import DashCloneForm from "./DashCloneForm";
import DashMoveForm from "./DashMoveForm";
import Badge from "@mui/material/Badge";
import CircularProgress from "@mui/material/CircularProgress";
//import DashCreationForm from "../generation/DashCreationForm";

import AttachRoleForm from "./AttachRoleForm";
import { RollerShades } from "@mui/icons-material";

/**
 * A single library item showing a Dash.
 *
 * @export
 * @param {{
 *   dash: Dash;
 * }} props
 * @return {*}
 */
export default function DashLibraryUser(props: {
  workspaceRole: string;
  user: User;
  roleId: number;
  workspaces: Array<Workspace> | null;
  currentWorkspace: Workspace | null;
}) {
  const actions = useActions();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const menuOpen = Boolean(anchorEl);
  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const [infoOpen, setInfoOpen] = React.useState(false);
  const [cloneOpen, setCloneOpen] = React.useState(false);
  const [moveOpen, setMoveOpen] = React.useState(false);

  const [attachRoleOpen, setAttachRoleOpen] = React.useState(false);

  const [generateOpen, setGenerateOpen] = React.useState(false);

  const handleFolderClicked = () => {
    console.log('Go in');
    //actions.changeFolder({id:props.folder.id, name:props.folder.name});
  };

  const handleDeleteClicked = () => {
    setAnchorEl(null);
    //actions.setEditingDash(props.folder);

    actions.unlinkRole({ roleId: props.roleId, userId: parseInt(props.user.id)});
  };
  const handleFavoriteClicked = () => {
    //setAnchorEl(null);
    //actions.favouriteDocumentTemplate(props.documentTemplate);
  };
  const handleUnfavoriteClicked = () => {
    //setAnchorEl(null);
    //actions.unfavouriteDocumentTemplate(props.documentTemplate);
  };
  const handleInfoClicked = () => {
    setAnchorEl(null);
    setInfoOpen(true);
  };

  const handleCloneToWorkspace = () => {
    setCloneOpen(true);
    setAnchorEl(null);
  };

  const handleMoveToWorkspace = () => {
    setMoveOpen(true);
    setAnchorEl(null);
  };

  const handleAttachRole = () => {
    setAttachRoleOpen(true);
    setAnchorEl(null);
  };

  const handleAttachRoleClose = () => {
    setAttachRoleOpen(false);
  };

  let itemContent = (
    <CircularProgress size="150px" style={{ padding: "10px" }} />
  );

  itemContent = (
    <PermIdIcon
        color={"primary"}
        sx={{ fontSize: 96 }}
      />
  );
  /*
  src={URL.createObjectURL(
          props.dash.imagePreview?.data as Blob
        )}
  if (
    !props.dash.imagePreview ||
    props.dash.imagePreview.data == null ||
    props.dash.imagePreview.status === "failed"
  ) {
    // Show the file icon
    itemContent = (
      <InsertDriveFileIcon
        color={isDeleted ? "inherit" : "primary"}
        sx={{ fontSize: 96 }}
      />
    );
  } else if (props.dash.imagePreview?.data !== null) {
    
  }*/

  return (
    <ImageListItem
      key={"role_but"}
      sx={{
        justifyContent: "center",
        display: "flex",
        width: 200,
        height: 250,
      }}
    >
      
      <Paper
        sx={{
          background: "#FFFFFF",
          justifyContent: "center",
          display: "flex",
          width: 200,
          height: 250,
        }}
      >
        
        
        <IconButton
            data-index={"role_but_1"}
            key={"role_but_2"}
            onClick={(e) => handleFolderClicked()}
            
          >
            
            {itemContent}
          </IconButton>
      </Paper>
      <ImageListItemBar
        title={props.user.email}
        position="below"
        actionIcon={
          <>
            <IconButton
              aria-label={props.user.email}
              onClick={handleOpenMenu}
            >
              <MoreVertIcon />
            </IconButton>
          </>
        }
        
      >
        
        </ImageListItemBar>

        <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}

      >
          <MenuItem onClick={handleDeleteClicked}>
            <ListItemIcon>
              <TrashIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Remove</ListItemText>
          </MenuItem>
        </Menu>
      
    </ImageListItem>
  );
}
